/**
 * Client-side auth cookie utilities
 * Handles JWT token storage in cookies (client-side accessible)
 */

const TOKEN_COOKIE_NAME = 'naka_auth_token';
const MAX_AGE = 60 * 60 * 24 * 7; // 7 days (longer than JWT 24h for convenience)

/**
 * Client-side cookie operations
 */
export const clientCookies = {
  /**
   * Set token in cookie (client-side)
   */
  setToken(token: string): void {
    if (typeof document === 'undefined') {
      // SSR context - no document
      return;
    }
    // TODO: Remove this bypass after testing - always use secure in production
    // Skip secure flag when accessing over HTTP (for VPS testing)
    const isHttps = typeof window !== 'undefined' && window.location.protocol === 'https:';
    const secure = isHttps ? 'secure;' : '';
    document.cookie = `${TOKEN_COOKIE_NAME}=${token}; path=/; max-age=${MAX_AGE}; ${secure} samesite=lax`;
  },

  /**
   * Get token from cookie (client-side)
   */
  getToken(): string | null {
    if (typeof document === 'undefined') {
      // SSR context - no document
      return null;
    }

    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === TOKEN_COOKIE_NAME) {
        return value || null;
      }
    }
    return null;
  },

  /**
   * Remove token cookie (client-side)
   */
  removeToken(): void {
    if (typeof document === 'undefined') {
      return;
    }
    document.cookie = `${TOKEN_COOKIE_NAME}=; path=/; max-age=0`;
  },
};
